import type { AppState } from '../../types';
import * as AppActionTypes from '../actions/action-types';

export function app(
  state: AppState = {
    status: 'initial',
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): AppState {
  switch (action.type) {
    case AppActionTypes.LOADED:
      return Object.assign({}, state, {
        status: 'loaded',
      });

    default:
      return state;
  }
}
